import { putQueryParam, toUrlT } from '@execonline-inc/url';
import { Maybe } from 'maybeasy';
import { Task } from 'taskarian';
import { callApi } from '../../../../Appy';
import { findLinkT } from '../../../../LinkyLinky';
import { Link } from '../../../../Resource/Types';
import { ProductLicenseResource } from '../../Types';
import { learningCollectionNewFormResourceDecoder } from '../Decoders';
import LearningCollectionStore from '../Store';
import { LearningCollectionError, ReloadAllExperiences } from '../Types';

export const buildUrl =
  (selectedProductLicense: Maybe<ProductLicenseResource>) =>
  (link: Link): Task<LearningCollectionError, Link> =>
    toUrlT(link.href)
      .map(
        putQueryParam(
          'product_license_id',
          selectedProductLicense.map((pl) => String(pl.payload.id)).getOrElseValue(''),
        ),
      )
      .map((url): Link => ({ ...link, href: url.href }));

const reloadAllExperiences = (
  store: LearningCollectionStore,
  links: ReadonlyArray<Link>,
  state: ReloadAllExperiences,
) =>
  Task.succeed<LearningCollectionError, ReadonlyArray<Link>>(links)
    .andThen(findLinkT('new-learning-collection'))
    .andThen(buildUrl(state.selectedProductLicense))
    .andThen(callApi(learningCollectionNewFormResourceDecoder, {}))
    .fork(store.loadError, store.building);

export default reloadAllExperiences;
